import gql from 'graphql-tag';

export const getArticleFields = (field) => `id
      title
      description
      body
      imageUrls(configurations: $imageConfigurations)
      imageCaption
      creator {
        email
        id
        name
      }
      tags {
        title
        slug
      }
      createdAt
      updatedAt
      keywords
      slug
      ${field !== 'newsArticle' ? 'path' : ''}
      category {
        id
        title
        path
      }
      reference
      labels
      featured`;

const getArticleQuery = (field, byPath) => gql`
  query NewsArticle(
    ${byPath ? '$path: String!' : '$id: Int!'}
    $imageConfigurations: [ResponsiveImageConfiguration]!,
    ) {
    ${field}${byPath ? '(path: $path)' : '(id: $id)'} {
      ${getArticleFields(field)}
    }
  }
`;

export default getArticleQuery;
